import { RoutesMounter } from '@/types';
import { VideoTutorialIndex } from './views/VideoTutorialIndex';

export const mountVideoTutorialRoutes: RoutesMounter = ({ path }) => [
  {
    path,
    children: [{ index: true, Component: VideoTutorialIndex }],
  },
];
